import React from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { fetchServer } from "../Base/modelManager";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Button, Container } from "react-bootstrap";
import { serverError } from "../../redux/actions/serverManagerAction";
import base64 from "react-native-base64";
import { message } from "antd";


class Adresses extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            data: {},
            original: {},
            loadding: false,
        }
    }

    componentDidMount() {
        if (this.props.currentClient !== undefined && this.props.currentClient !== null)
            this.getCurrentAdresses()
    }

    componentDidUpdate(prevProp) {
        if (this.props.currentClient !== undefined && this.props.currentClient !== null)
            if (prevProp.currentClient !== this.props.currentClient) {
                this.getCurrentAdresses()

            }
    }
    getCurrentAdresses = () => {
        const { loading } = this.state

        if (!loading) {

            this.setState({
                loading: true,
                data: {}
            })
            const request = {
                endPoint: this.props.apiUrl + '/Services/Clients/adresse',
                method: 'GET',
                token: this.props.JWTToken
            }
            fetchServer(request,
                (json) => {

                    this.setState({ original: { ...json }, data: { ...json }, loading: false })
                },
                (json) => {

                    this.props.dispatch(serverError(json.error))
                }


            )
        }
    }


    onPropertyChange = (event) => {
        const { data } = this.state
        data[event.target.name] = event.target.value
        this.setState({ data: { ...data } })
    }

    onKbisSelected = (event) => {
        const file = event.currentTarget.files[0]

        var base64File

        let reader = new FileReader();
        reader.onload = (e) => {
            base64File = base64.encode(e.target.result)

            const fileData = {
                fileName: file.name,
                mimeType: file.type,

                content: base64File
            }
            //fileSize: file.size,

            this.setState({ Kbis: fileData })
        }

        reader.readAsBinaryString(file);
    }

    updateDetected = () => {
        const { original, data } = this.state
        let result = Object.keys(original).some(item => {
            return original[item]!==data[item]

        })
        return result
    }

    dataValid=()=>{
        const {data}= this.state
        return data.nom!=='' && data.codepostal!=='' && data.ville!=='' && (data.adresse1!=='' || data.adresse2!=='' || data.adresse3!=='')
        && data.nomfact!=='' && data.cpfact!=='' && data.villef!=='' && (data.adrfact1!=='' || data.adrfact2!=='' || data.adrfact3!=='')
    }


    render() {
        const { data } = this.state

        return (
            <section>
                <Container id="AdrCorrespondance" className="justify-content-md-center">
                    <Row className="header">
                        - ADRESSE DE CORRESPONDANCE -
                    </Row>
                    <Row>
                        <Col sm="3">
                            Raison Sociale
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='nom' value={data.nom} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            ADRESSE
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='adresse1' value={data.adresse1} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">

                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='adresse2' value={data.adresse2} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">

                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='adresse3' value={data.adresse3} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            CODE POSTAL
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='codepostal' value={data.codepostal} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            VILLE
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='ville' value={data.ville} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row >
                        <Col sm="3" >
                            Kbis* (pdf)
                        </Col>
                        <Col sm="9">
                            <Form.Control accept=".jpg, .pdf, .bmp" type="file" name='kbis' value={data.kbis} onChange={this.onKbisSelected} />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center" style={{ fontSize: 'smaller' }}>
                        *pour valider la demande de changement d'adresse un extrait Kbis de moins de 3 mois doit etre téléchargé
                    </Row>
                </Container>


                <Container id="AdrFacturation" className="justify-content-md-center">
                    <Row className="header">
                        - ADRESSE DE FACTURATION -
                    </Row>
                    <Row>
                        <Col sm="3">
                            Raison Sociale
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='nomfact' value={data.nomfact} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            ADRESSE
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='adrfact1' value={data.adrfact1} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">

                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='adrfact2' value={data.adrfact2} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">

                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='adrfact3' value={data.adrfact3} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            CODE POSTAL
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='cpfact' value={data.cpfact} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="3">
                            VILLE
                        </Col>
                        <Col sm="9">
                            <Form.Control type="text" name='villefact' value={data.villefact} onChange={this.onPropertyChange} />
                        </Col>
                    </Row>
                </Container>

                {this.props.currentClient ?// && this.props.currentClient.gestion === true ?
                    <Row className="justify-content-md-center">
                        <Button id='saveAdresse' disabled={(this.state.Kbis === undefined) || !this.updateDetected() || !this.dataValid()} onClick={() => {
                            if (this.state.Kbis === undefined) {
                                message.error('L\'ajout d\'un extrait Kbis est obligatoire pour émettre la demande changement d\'adresse.', 5)
                                return
                            }

                            const request = {
                                endPoint: this.props.apiUrl + '/Services/Clients/updateClientAdresse',
                                method: 'POST',
                                params: {
                                    clientid: this.props.currentClient.uid,
                                    values: {
                                        ...data,
                                        kbis: this.state.Kbis
                                    }
                                },
                                token: this.props.JWTToken
                            }
                            fetchServer(request,
                                (json) => {
                                    message.info('Votre demande a bien été enregistrée. Elle sera traitée, par votre service client, dans les plus brefs délais. Un email vous confirmera la prise en compte de votre demande.', 10)
                                    this.setState({ loading: false })
                                },
                                (json) => {
                                    this.setState({ data: {}, loading: false })
                                    this.props.dispatch(serverError(json.error))
                                }


                            )
                        }}>Enregistrer</Button>
                    </Row>
                    : null
                }

            </section>
        )
    }
}


const mapStateToProps = (state) => {

    return ({
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

Adresses.propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string,
    apiUrl: PropTypes.string
};

export default connect(mapStateToProps)(Adresses);
